// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { FactoryWithChoiceContext } from '@digitalasset/utility-operator-api-ts-client';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { Holding } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Holding';
import { ContractId } from '@daml/types';
import { useUtilityRegistryApiClient } from '../../../../../contexts/UtilityRegistryApiContext';

export const useCreateBurnRequestContext: () => UseMutationResult<
  FactoryWithChoiceContext,
  string,
  {
    registrar: string;
    holder: string;
    holdingContractIds: ContractId<Holding>[];
    instrumentId: string;
  }
> = () => {
  const registryApi = useUtilityRegistryApiClient();

  return useMutation({
    mutationKey: ['createBurnRequestContext', registryApi],
    mutationFn: async ({ registrar, holder, holdingContractIds, instrumentId }) => {
      const requestBurnRequest = {
        holder,
        holdingContractIds,
        instrumentId: {
          admin: registrar,
          id: instrumentId,
        },
      };
      return registryApi.getBurnRequestCreateContext(requestBurnRequest);
    },
  });
};
